var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, formatPositionAcronym } from '@shapeable/utils';
var cls = classNames('person-bio-cell');
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { EntityBubbleImage } from './entity-bubble-image';
import { useEntity } from '../hooks/use-entity';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
import { DottedChevronRightHeavyIconGlyph, LinkedinFilledIconGlyph, TwitterFilledIconGlyph, SiteIcon } from '@shapeable/icons';
import { startCase } from 'lodash';
import { useTooltipEffect } from '../hooks/use-tooltip-effect';
import { Badge } from '../elements/badge';
import { useComponentPropsFor } from '../context/component-props-context';
export var PersonBioCellDefaultProps = {
  showOrganisation: false,
  showEmailContact: false,
  useTooltip: true,
  useProfile: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "])), function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        filter: brightness(1.05);\n      }\n    "], ["\n      &:hover {\n        filter: brightness(1.05);\n      }\n    "])));
  })
});
var PhotoStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 1em;\n    line-height: 1.1em;\n    margin: ", " 0 0;\n  "], ["\n    color: ", ";\n    font-size: 1em;\n    line-height: 1.1em;\n    margin: ", " 0 0;\n  "])), theme.COLOR('strong'), theme.UNIT(4))
});
var IconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    height: 24px;\n    width: 24px;\n  "], ["\n    ", ";\n    height: 24px;\n    width: 24px;\n  "])), theme.FILL(cls.color(), 'secondary'))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 21px;\n    ", ";\n    color: ", ";\n  "], ["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 21px;\n    ", ";\n    color: ", ";\n  "])), theme.COLOR(cls.color(), 'sub'), theme.UNIT(0), theme.UNIT(4), theme.FONT_SIZE(13), theme.FILL(cls.color(), 'sub'), theme.COLOR(cls.color(), 'sub'))
});
var ButtonIconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 7px;\n    margin-left: ", ";\n  "], ["\n    width: 7px;\n    margin-left: ", ";\n  "])), theme.UNIT(2))
});
var BodyStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "], ["\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "])), function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  })
});
var PositionStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-weight: 400;\n    color: ", ";\n    margin-top: ", ";\n  "], ["\n    font-weight: 400;\n    color: ", ";\n    margin-top: ", ";\n  "])), theme.COLOR('text'), theme.UNIT(1))
});
var FooterStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])))
});
var SocialsAndBioStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    gap: ", ";\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: row;\n    gap: ", ";\n    margin-top: ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var BioStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EmailButtonStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n  "])), ButtonStyles, theme.UNIT(2))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(1))
});
var ActiveBadgeStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " ", ";\n    margin-top: ", ";\n  "], ["\n    padding: ", " ", ";\n    margin-top: ", ";\n  "])), theme.UNIT(1), theme.UNIT(2), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Photo: styled(EntityBubbleImage)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Name: styled.h1.attrs(cls.attr('name'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Bio: styled(ContentNode)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BioStyles),
  Position: styled.span.attrs(cls.attr('position'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Organisation: styled.span.attrs(cls.attr('organisation'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  SocialsAndBio: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), SocialsAndBioStyles),
  LinkedinIcon: styled(LinkedinFilledIconGlyph)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  TwitterIcon: styled(TwitterFilledIconGlyph)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  WebIcon: styled(SiteIcon)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  WebsiteButton: styled.a.attrs(cls.attr('website-button'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  EmailButton: styled.a.attrs(cls.attr('email-button'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), EmailButtonStyles),
  BioButton: styled.span.attrs(cls.attr('button'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  ProfileButton: styled.a.attrs(cls.attr('button'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  ButtonIcon: styled(DottedChevronRightHeavyIconGlyph)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ButtonIconStyles),
  ActiveBadge: styled(Badge)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ActiveBadgeStyles)
};
export var PersonBioCell = function (props) {
  var _a = useComponentPropsFor('PersonBioCell', PersonBioCellDefaultProps, props),
    className = _a.className,
    children = _a.children,
    showOrganisation = _a.showOrganisation,
    useTooltip = _a.useTooltip,
    transform = _a.transform,
    showEmailContact = _a.showEmailContact,
    useProfile = _a.useProfile;
  var entity = useEntity(props.entity);
  var linkedin = entity.linkedin,
    twitter = entity.twitter,
    slug = entity.slug,
    websiteUrl = entity.websiteUrl,
    name = entity.name,
    position = entity.position,
    bio = entity.bio,
    organisation = entity.organisation,
    badge = entity.badge,
    path = entity.path;
  var Link = useLink().Link;
  var t = useLang();
  useTooltipEffect();
  var hasOrganisation = showOrganisation && !!organisation && organisation.name;
  var hasWebsite = !!websiteUrl;
  var hasBio = !!(bio && bio.html);
  var hasEmailContact = showEmailContact && !!entity.email;
  var hasProfile = useProfile && !!path;
  var isClickable = hasWebsite || hasBio || hasProfile;
  var hasFooter = hasBio || hasWebsite || linkedin || twitter || badge || hasProfile;
  var shouldOpenWebsite = (!hasBio || !useTooltip) && hasWebsite;
  // Adjusted logic so that profile || website || bio can be clicked from top and linked accordingly.
  var clickInfo = shouldOpenWebsite ? {
    url: websiteUrl,
    newTab: true
  } : hasProfile ? {
    url: path,
    newTab: false
  } : null;
  var onClick = clickInfo ? function () {
    return window.open(clickInfo.url, clickInfo.newTab ? '_blank' : '_self');
  } : function () {};
  var tooltipProps = useTooltip && hasBio ? {
    "data-event": "click",
    "data-tip": bio && bio.html || '',
    "data-html": true
  } : {};
  var swallowEvent = function (event) {
    event.stopPropagation();
  };
  return React.createElement(My.Container, {
    onClick: onClick,
    isClickable: isClickable,
    className: cls.name(className)
  }, React.createElement(My.Body, __assign({
    isClickable: isClickable
  }, tooltipProps), React.createElement(My.Photo, {
    transform: transform,
    size: 112,
    entity: entity
  }), React.createElement(My.Name, null, name), position && React.createElement(My.Position, null, formatPositionAcronym(position)), hasOrganisation && React.createElement(My.Organisation, null, startCase(organisation.name.toLowerCase())), hasEmailContact && React.createElement(My.EmailButton, {
    onClick: swallowEvent,
    href: "mailto:".concat(entity.email)
  }, t('Contact'), React.createElement(My.ButtonIcon, null)), hasFooter && React.createElement(My.Footer, null, React.createElement(My.SocialsAndBio, null, twitter && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Twitter'),
    href: twitter,
    target: "_blank"
  }, React.createElement(My.TwitterIcon, null)), linkedin && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Linkedin'),
    href: linkedin,
    target: "_blank"
  }, React.createElement(My.LinkedinIcon, null)), hasWebsite && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Website'),
    href: websiteUrl,
    target: "_blank"
  }, React.createElement(My.WebIcon, null)), hasProfile ? React.createElement(My.ProfileButton, {
    href: path
  }, t('Profile'), React.createElement(My.ButtonIcon, null)) : hasBio && React.createElement(My.BioButton, null, t('Bio'), React.createElement(My.ButtonIcon, null))), badge && React.createElement(My.ActiveBadge, null, t('Active')))));
};
// PersonBioCell.defaultProps = PersonBioCellDefaultProps;
PersonBioCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34;